module.exports = "<p>\r\n  table-viewer works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_Components/table-viewer/table-viewer.component.html
// module id = 415
// module chunks = 1